import React from 'react';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { getSrpSeoObject } from 'site-modules/shared/utils/inventory/srp-seo-object';
import { pageDefinitionConfiguration, getPreload } from './usurp-definition';

import { UsurpContainer } from './usurp-container';

export const getPageDefinitionConfig = params => ({
  ...pageDefinitionConfiguration,
  name: 'make_type_srp',
  preload: (store, props) => getPreload(store, props, params),
  seo: (state, props) => getSrpSeoObject(state, props, params),
  component: props => <UsurpContainer {...props} isSrpOnMakeType />,
});

export default params => pageDefinition(getPageDefinitionConfig(params));
